<template>
<div class="chapter">
<div class="inner_page">
<div class="chapter" id="chapter07">
<a id="page8">
</a><div class="chapterHead"><a id="page8">
</a><h2 class="chapterTitle"><a id="page8"><span class="xrefInternal"></span></a><a href="#/004TOC#chapter_07"><span class="bold">THE PHONE RINGS–SNAPPING ME BACK TO THE PRESENT</span></a></h2></div>
<div class="chapterBody">
<div class="extract">
<p class="extractVerse" style="text-indent: 0%; margin-left: 5%;">It’s my mother.</p>
<p class="extractVerse" style="text-indent: 0%; margin-left: 5%;">“Hi, Mom,” I say, trying to sound cheery.</p>
<p class="extractVerse" style="text-indent: 0%; margin-left: 5%;">“What’s wrong, Holly?” she asks.</p>
</div>
<div class="extract">
<p class="extractVerse" style="text-indent: 0%; margin-left: 5%;">That is so annoying.</p>
<p class="extractVerse" style="text-indent: 0%; margin-left: 5%;">“Nothing is wrong,” I say.</p>
<p class="extractVerse" style="text-indent: 0%; margin-left: 5%;">“Do you want to talk about it, dear?” she asks.</p>
</div>
<div class="extract">
<p class="extractVerse" style="text-indent: 0%; margin-left: 5%;">“No!” I say,</p>
<p class="extractVerse" style="text-indent: 0%; margin-left: 5%;">feeling more transparent than Saran Wrap</p>
<p class="extractVerse" style="text-indent: 0%; margin-left: 5%;">and terribly sorry for myself.</p>
</div>
<div class="extract">
<p class="extractVerse" style="text-indent: 0%; margin-left: 5%;">There’s a brief silence, then my mother says,</p>
<p class="extractVerse" style="text-indent: 0%; margin-left: 5%;">“So…How’s the weather in California?”</p>
<p class="extractVerse" style="text-indent: 0%; margin-left: 5%;">“Sunny,” I sigh. “I am so tired <em class="italic">of sunny.”</em></p>
</div>
<div class="extract">
<p class="extractVerse" style="text-indent: 0%; margin-left: 5%;">“It’s sunny here in Cleveland, too,” she says.</p>
<p class="extractVerse" style="text-indent: 0%; margin-left: 5%;">“But with that crisp October tang in the air.</p>
<p class="extractVerse" style="text-indent: 0%; margin-left: 5%;">I had such fun raking the leaves this morning…”</p>
</div>
<div class="extract">
<p class="extractVerse" style="text-indent: 0%; margin-left: 5%;">“Mom,” I gasp, “you’re eighty years old!”</p>
<p class="extractVerse" style="text-indent: 0%; margin-left: 5%;">“Don’t rub it in.”</p>
<p class="extractVerse" style="text-indent: 0%; margin-left: 5%;">“But you shouldn’t be raking leaves!”</p>
</div>
<div class="extract">
<p class="extractVerse" style="text-indent: 0%; margin-left: 5%;">“Oh, bosh!” she says, “I’d have jumped</p>
<p class="extractVerse" style="text-indent: 0%; margin-left: 5%;">in them, too, if my handsome new neighbor</p>
<p class="extractVerse" style="text-indent: 0%; margin-left: 5%;">hadn’t been watching me from his window.”</p>
</div>
<a id="page9">
<div class="extract">
<p class="extractVerse" style="text-indent: 0%; margin-left: 5%;">“Geez. You might have broken something!”</p>
<p class="extractVerse" style="text-indent: 0%; margin-left: 5%;">“You’re right,” she says with a girlish giggle.</p>
<p class="extractVerse" style="text-indent: 0%; margin-left: 5%;">“I might have broken my neighbor’s heart.”</p>
</div>
<div class="extract">
<p class="extractVerse" style="text-indent: 0%; margin-left: 5%;">I can’t help smiling at this, but then she says,</p>
<p class="extractVerse" style="text-indent: 0%; margin-left: 5%;">“What about <em class="italic">your</em> heart, Holly?</p>
<p class="extractVerse" style="text-indent: 0%; margin-left: 5%;">Why is it so heavy today?”</p>
</div>
<div class="extract">
<p class="extractVerse" style="text-indent: 0%; margin-left: 5%;">So,</p>
<p class="extractVerse" style="text-indent: 0%; margin-left: 5%;">of course,</p>
<p class="extractVerse" style="text-indent: 0%; margin-left: 5%;">I tell her everything.</p>
</div>
<div class="extract">
<p class="extractVerse" style="text-indent: 0%; margin-left: 5%;">And when I finish,</p>
<p class="extractVerse" style="text-indent: 0%; margin-left: 5%;">she says, “Your baby-making days</p>
<p class="extractVerse" style="text-indent: 0%; margin-left: 5%;">may be over, but you will always be <em class="italic">my</em> baby.”</p>
</div>
<div class="extract">
<p class="extractVerse" style="text-indent: 0%; margin-left: 5%;">And, for reasons I can’t quite fathom,</p>
<p class="extractVerse" style="text-indent: 0%; margin-left: 5%;">her words are as soothing</p>
<p class="extractVerse" style="text-indent: 0%; margin-left: 5%;">as a cup of chamomile tea.</p>
</div>
</a></div><a id="page9">
</a></div>
<a id="page9">
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 011-chapter07.vue?558553d7